import { useState, useCallback } from 'react';

export const useSceneInteraction = (onSpotSelect, forceUnlock) => {
    const [canInteract, setCanInteract] = useState(true);
    const [selectedSpot, setSelectedSpot] = useState(null);
    const [isShowMode, setIsShowMode] = useState(false);

    const handleSpotSelect = useCallback((spotId, isEditMode) => {
        console.log('useSceneInteraction handleSpotSelect:', {
            spotId,
            isEditMode,
            isShowMode,
            currentSelectedSpot: selectedSpot
        });

        // In show mode, only allow viewing assets, no editing
        if (isShowMode) {
            if (isEditMode) return; // Prevent any edit mode actions in show mode
            console.log('Show mode spot selection:', spotId);
            setSelectedSpot(spotId);
            onSpotSelect(spotId, false); // Always pass false in show mode
            return;
        }
        
        // For edit mode, keep existing behavior
        if (isEditMode) {
            forceUnlock();
        }
        
        setSelectedSpot(spotId);
        onSpotSelect(spotId, isEditMode);
    }, [isShowMode, onSpotSelect, forceUnlock, selectedSpot]);

    const toggleShowMode = useCallback(() => {
        setIsShowMode(prev => {
            const newShowMode = !prev;
            // Clear selection when entering show mode
            if (newShowMode) {
                setSelectedSpot(null);
                setCanInteract(false);
            } else {
                setCanInteract(true);
            }
            return newShowMode;
        });
    }, []);

    return {
        canInteract,
        selectedSpot,
        isShowMode,
        handleSpotSelect,
        toggleShowMode,
        setCanInteract,
        setSelectedSpot
    };
}; 